export const SRP_PROPERTY = {
    activities: 'activities',
    departments: 'departments',
    genders: 'genders',
    brands: 'brands',
    categories: 'categories',
    colors: 'colors',
    sizes: 'sizes',
    priceMin: 'price_min',
    priceMax: 'price_max',
    materials: 'materials',
};
